module.exports = __webpack_public_path__ + "img/banner1.415d516e.png";